import React, { useState, useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-login.module.css'; // You can move styles here
import image4 from '../assets/images/spherelogo1.png';
import { Navigate, useNavigate, Link } from 'react-router-dom';
import { LoginApi, LoginCSRF, LogoutApi } from '../components/ApiProperty';
import axios from 'axios';
// import { SessionProvider } from "./components/SessionContext";
import { useSession } from '../components/SessionContext';
import { useLocation } from "react-router-dom";



// import { useSession } from './components/SessionContext';

const Login = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [dynamicText, setDynamicText] = useState('Welcome to Gapsphere!');
    const [slideIndex, setSlideIndex] = useState(0);
    const [animate, setAnimate] = useState(false);
    const { setSessionId } = useSession();
    const location = useLocation();
    const [failCount, setFailCount] = useState(0);
    const [isLoginDisabled, setIsLoginDisabled] = useState(false);
    const [lockoutEndTime, setLockoutEndTime] = useState(null);
    const [timeLeft, setTimeLeft] = useState(0);


    // const { setSessionId } = useSession();
    const dynamicSlides = [
        {
            title: "Welcome to Gapsphere.AI!",
            lead: ""
        },
        {
            title: "Versatile Template Management",
            lead: "70+ Pre-Built Templates | Quick & Bulk Upload"
        },
        {
            title: "AI-Powered Data Ingestion",
            lead: "Chatbot Assistance | Multi-Format Imports (PDF, Image, Unstructured)"
        },
        {
            title: "Secure Approval & Audit Trail",
            lead: "Maker-Checker Workflow | Authenticated & Traceable"
        },
        {
            title: "Data Versioning & History",
            lead: "Track Changes Over Time | Retrieve Historical Data"
        },
        {
            title: "Department-Based Access Control",
            lead: "Structured Folders | Role-Based Visibility"
        }
    ];


    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex(prev => {
                const next = (prev + 1) % dynamicSlides.length;
                setAnimate(true); // trigger animation
                return next;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (animate) {
            const timer = setTimeout(() => setAnimate(false), 500); // match animation duration
            return () => clearTimeout(timer);
        }
    }, [animate]);

    useEffect(() => {
        const savedTime = parseInt(localStorage.getItem("lockoutEndTime"));
        if (savedTime && savedTime > Date.now()) {
            setIsLoginDisabled(true);
            setLockoutEndTime(savedTime);
        }
    }, []);

    const togglePassword = () => {
        setPasswordVisible(!passwordVisible);
    };

    const [values, setValues] = useState({
        email: "",
        password: "",
    });

    const [errorMessage, setErrorMessage] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [powerUser, setPowerUser] = useState(false);
    const navigate = useNavigate();

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     // axios.post("http://172.16.119.156:8081/api/user/login", {
    //     axios.post(LoginApi, {
    //         userId: values.email,
    //         password: values.password
    //     }).then(res => {

    //         if (res.data.status === "error") {
    //             if (res.data.message === "User account password expired." && res.data.first_login_flag === "Y") {
    //                 localStorage.setItem("userid", values.email);
    //                 localStorage.setItem("status", res.data.first_login_flag);
    //                 navigate("/ResetPassword");
    //                 return;
    //             } else {
    //                 setErrorMessage(res.data.message || "An error occurred. Please try again.");
    //                 return;
    //             }
    //         }
    //         const sessionId = res.data.sessionId;
    //         setSessionId(res.data.sessionId);
    //         if (!sessionId) {
    //             setErrorMessage("Session ID missing in response. Please try again.");
    //             return;
    //         }

    //         // Store sessionId for future use


    //         if (res.data.userAuth.userId === undefined || res.data.userAuth.userId === "" || res.data.userAuth.userId === null) {
    //             console.log("inside if");
    //             setErrorMessage("Invalid UserName or password. Please try again.");
    //             navigate("/");
    //         }

    //         else {
    //             console.log("inside else")
    //             if (res.data.userAuth.first_login_flag === "Y") {
    //                 localStorage.setItem("userid", res.data.userAuth.userId);
    //                 localStorage.setItem("status", res.data.userAuth.first_login_flag);
    //                 navigate("/ResetPassword");
    //                 return;
    //             }

    //             localStorage.setItem("username", res.data.userAuth.username);
    //             localStorage.setItem("userid", res.data.userAuth.userId);
    //             localStorage.setItem("lastLogin", res.data.userAuth.lastLogin);
    //             // for superUser functionality
    //             let role = res.data.userAuth.userRole;
    //             // Store the original role for later checks
    //             localStorage.setItem("originalUserRole", role);

    //             if (role === "Superuser") {
    //                 role = "Admin";
    //             }
    //             localStorage.setItem("userRole", role);

    // localStorage.setItem("Email_Id", res.data.userAuth.Email_Id);
    // const dept = res.data.userAuth.Orghie;
    // localStorage.setItem("dept", dept);
    // sessionStorage.setItem("dept", dept);
    // console.log("dept", dept);
    // localStorage.setItem("uploaded_template_count", res.data.UserActivity.uploaded_template_count);
    // localStorage.setItem("modified_template_count", res.data.UserActivity.modified_template_count);
    // localStorage.setItem("download_data_count", res.data.UserActivity.download_data_count);

    // localStorage.setItem("num_logins", res.data.UserSummary.num_logins);
    // localStorage.setItem("last_activity", res.data.UserSummary.last_activity);
    // localStorage.setItem("frequent_activity", res.data.UserSummary.frequent_activity);

    // //organization hierarchy
    // localStorage.setItem("Mapped_Name", res.data.UserOrganizationHierarchy.Mapped_Name);
    // localStorage.setItem("Mapped_Role", res.data.UserOrganizationHierarchy.Mapped_Role);
    // localStorage.setItem("Mapped_Email", res.data.UserOrganizationHierarchy.Mapped_Email);


    //             localStorage.setItem("Data_Log", res.data.UserCompletedActivitiesCount.Data_Log);
    //             localStorage.setItem("Data_Log_DEM", res.data.UserCompletedActivitiesCount.Data_Log_DEM);
    //             localStorage.setItem("Data_Log_BDM", res.data.UserCompletedActivitiesCount.Data_Log_BDM);
    //             localStorage.setItem("DataDeleted", res.data.UserCompletedActivitiesCount.DataDeleted);
    //             localStorage.setItem("DataDeleted_DEM", res.data.UserCompletedActivitiesCount.DataDeleted_DEM);
    //             localStorage.setItem("DataDeleted_BDM", res.data.UserCompletedActivitiesCount.DataDeleted_BDM);
    //             localStorage.setItem("RetrievedDataLogged", res.data.UserCompletedActivitiesCount.RetrievedDataLogged);
    //             localStorage.setItem("RetrievedDataLogged_DEM", res.data.UserCompletedActivitiesCount.RetrievedDataLogged_DEM);
    //             localStorage.setItem("RetrievedDataLogged_BDM", res.data.UserCompletedActivitiesCount.RetrievedDataLogged_BDM);
    //             localStorage.setItem("RetrievedDataDeleted", res.data.UserCompletedActivitiesCount.RetrievedDataDeleted);
    //             localStorage.setItem("RetrievedDataDeleted_DEM", res.data.UserCompletedActivitiesCount.RetrievedDataDeleted_DEM);
    //             localStorage.setItem("RetrievedDataDeleted_BDM", res.data.UserCompletedActivitiesCount.RetrievedDataDeleted_BDM);
    //             //new
    //             localStorage.setItem("Data_Entry_Management_COM_MA", res.data.UserCompletedActivitiesCount.Data_Entry_Management_COM_MA);
    //             localStorage.setItem("DEM_Logged_Data_M", res.data.UserCompletedActivitiesCount.DEM_Logged_Data_M);
    //             localStorage.setItem("DEM_Modified_Data_M", res.data.UserCompletedActivitiesCount.DEM_Modified_Data_M);
    //             localStorage.setItem("Bulk_Data_Management_COM_MA", res.data.UserCompletedActivitiesCount.Bulk_Data_Management_COM_MA);
    //             localStorage.setItem("BDM_Uploaded_Data_M", res.data.UserCompletedActivitiesCount.BDM_Uploaded_Data_M);
    //             localStorage.setItem("BDM_Modified_Data_M", res.data.UserCompletedActivitiesCount.BDM_Modified_Data_M);

    //             //admin
    //             localStorage.setItem("DataLogged", res.data.UserCompletedActivitiesCount.DataLogged);
    //             localStorage.setItem("DataLogged_RDM", res.data.UserCompletedActivitiesCount.DataLogged_RDM);
    //             localStorage.setItem("TemplatesCreated", res.data.UserCompletedActivitiesCount.TemplatesCreated);
    //             localStorage.setItem("TemplatesCreated_DEM", res.data.UserCompletedActivitiesCount.TemplatesCreated_DEM);
    //             localStorage.setItem("TemplatesCreated_BDM", res.data.UserCompletedActivitiesCount.TemplatesCreated_BDM);
    //             localStorage.setItem("DataRetrieved", res.data.UserCompletedActivitiesCount.DataRetrieved);
    //             localStorage.setItem("DataRetrieved_RDM", res.data.UserCompletedActivitiesCount.DataRetrieved_RDM);
    //             localStorage.setItem("DataRetrieved_DEM", res.data.UserCompletedActivitiesCount.DataRetrieved_DEM);
    //             localStorage.setItem("DataRetrieved_BDM", res.data.UserCompletedActivitiesCount.DataRetrieved_BDM);
    //             localStorage.setItem("TemplatesRestored", res.data.UserCompletedActivitiesCount.TemplatesRestored);
    //             localStorage.setItem("TemplatesRestored_DEM", res.data.UserCompletedActivitiesCount.TemplatesRestored_DEM);
    //             localStorage.setItem("TemplatesRestored_BDM", res.data.UserCompletedActivitiesCount.TemplatesRestored_BDM);
    //             //new
    //             localStorage.setItem("Data_Entry_Management_COM", res.data.UserCompletedActivitiesCount.Data_Entry_Management_COM);
    //             localStorage.setItem("DEM_Logged_Templates", res.data.UserCompletedActivitiesCount.DEM_Logged_Templates);
    //             localStorage.setItem("DEM_Modified_Templates", res.data.UserCompletedActivitiesCount.DEM_Modified_Templates);
    //             localStorage.setItem("Bulk_Data_Management_COM", res.data.UserCompletedActivitiesCount.Bulk_Data_Management_COM);
    //             localStorage.setItem("BDM_Logged_Templates", res.data.UserCompletedActivitiesCount.BDM_Logged_Templates);
    //             localStorage.setItem("BDM_Modified_Templates", res.data.UserCompletedActivitiesCount.BDM_Modified_Templates);
    //             localStorage.setItem("Reference_Data_Management_COM", res.data.UserCompletedActivitiesCount.Reference_Data_Management_COM);
    //             localStorage.setItem("RDM_Uploaded_Data_C", res.data.UserCompletedActivitiesCount.RDM_Uploaded_Data_C);
    //             localStorage.setItem("RDM_Modified_Data_C", res.data.UserCompletedActivitiesCount.RDM_Modified_Data_C);
    //             localStorage.setItem("Backup_Restore_Management_COM", res.data.UserCompletedActivitiesCount.Backup_Restore_Management_COM);
    //             localStorage.setItem("BRM_Restored_Data", res.data.UserCompletedActivitiesCount.BRM_Restored_Data);
    //             localStorage.setItem("BRM_Restored_Templates", res.data.UserCompletedActivitiesCount.BRM_Restored_Templates);


    //             //checker
    //             localStorage.setItem("DataApproved", res.data.UserCompletedActivitiesCount.DataApproved);
    //             localStorage.setItem("DataApproved_RDM", res.data.UserCompletedActivitiesCount.DataApproved_RDM);
    //             localStorage.setItem("DataApproved_DEM", res.data.UserCompletedActivitiesCount.DataApproved_DEM);
    //             localStorage.setItem("DataApproved_BDM", res.data.UserCompletedActivitiesCount.DataApproved_BDM);
    //             localStorage.setItem("TemplatesApproved", res.data.UserCompletedActivitiesCount.TemplatesApproved);
    //             localStorage.setItem("TemplatesApproved_DEM", res.data.UserCompletedActivitiesCount.TemplatesApproved_DEM);
    //             localStorage.setItem("TemplatesApproved_BDM", res.data.UserCompletedActivitiesCount.TemplatesApproved_BDM);
    //             localStorage.setItem("RetrievedDataApproved", res.data.UserCompletedActivitiesCount.RetrievedDataApproved);
    //             localStorage.setItem("RetrievedDataApproved_RDM", res.data.UserCompletedActivitiesCount.RetrievedDataApproved_RDM);
    //             localStorage.setItem("RetrievedDataApproved_DEM", res.data.UserCompletedActivitiesCount.RetrievedDataApproved_DEM);
    //             localStorage.setItem("RetrievedDataApproved_BDM", res.data.UserCompletedActivitiesCount.RetrievedDataApproved_BDM);
    //             localStorage.setItem("RestoredTemplatesApproved", res.data.UserCompletedActivitiesCount.RestoredTemplatesApproved);
    //             localStorage.setItem("RestoredTemplatesApproved_DEM", res.data.UserCompletedActivitiesCount.RestoredTemplatesApproved_DEM);
    //             localStorage.setItem("RestoredTemplatesApproved_BDM", res.data.UserCompletedActivitiesCount.RestoredTemplatesApproved_BDM);
    //             //new
    //             localStorage.setItem("Data_Entry_Management_COM_CH", res.data.UserCompletedActivitiesCount.Data_Entry_Management_COM_CH);
    //             localStorage.setItem("DEM_Approved_Data", res.data.UserCompletedActivitiesCount.DEM_Approved_Data);
    //             localStorage.setItem("DEM_Approved_Templates", res.data.UserCompletedActivitiesCount.DEM_Approved_Templates);
    //             localStorage.setItem("Bulk_Data_Management_COM_CH", res.data.UserCompletedActivitiesCount.Bulk_Data_Management_COM_CH);
    //             localStorage.setItem("BDM_Approved_Data", res.data.UserCompletedActivitiesCount.BDM_Approved_Data);
    //             localStorage.setItem("BDM_Approved_Templates", res.data.UserCompletedActivitiesCount.BDM_Approved_Templates);
    //             localStorage.setItem("Reference_Data_Management_COM_CH", res.data.UserCompletedActivitiesCount.Reference_Data_Management_COM_CH);
    //             localStorage.setItem("RDM_Approved_Data", res.data.UserCompletedActivitiesCount.RDM_Approved_Data);
    //             localStorage.setItem("Backup_Restore_Management_COM_CH", res.data.UserCompletedActivitiesCount.Backup_Restore_Management_COM_CH);
    //             localStorage.setItem("BRM_Approved_Restored_Data", res.data.UserCompletedActivitiesCount.BRM_Approved_Restored_Data);
    //             localStorage.setItem("BRM_Approved_Restored_Templates", res.data.UserCompletedActivitiesCount.BRM_Approved_Restored_Templates);

    //             //new desgin
    //             const activities = res.data.UserCompletedActivitiesCount;

    //             Object.keys(activities).forEach(activity => {
    //                 const { tablenames, count } = activities[activity];
    //                 localStorage.setItem(activity, JSON.stringify({ tablenames, count }));
    //             });

    //             // Console log before storing Data_Entry_Management
    //             if (activities.Data_Entry_Management) {
    //                 console.log("Data_Entry_Management_COM:", activities.Data_Entry_Management_COM);
    //                 localStorage.setItem("Data_Entry_Management_COM", JSON.stringify(activities.Data_Entry_Management_COM));
    //             } else {
    //                 console.log(" undefined or missing.");
    //             }

    //             // localStorage.setItem("sessionId", sessionId);
    //             // sessionStorage.setItem("sessionId", sessionId);

    //             const userRole = res.data.userAuth.userRole;

    //             const roleRouteMap = {
    //                 Admin: "/gapsyAdashboard",
    //                 Checker: "/gapsyCdashboard",
    //                 Maker: "/gapsyMdashboard",
    //                 // Superuser: "/Superuser"
    //                 // Add other roles if needed
    //             };

    //             const targetRoute = roleRouteMap[userRole] || "/gapsyAdashboard";
    //             setIsLoggedIn(true);
    //             navigate(targetRoute);
    //             // navigate(targetRoute, { state: { sessionId } });
    //             console.log("aaaa");
    //             // setIsLoggedIn(true);
    //             // navigate("/Dashboard");
    //         }
    //     }).catch(err => {
    //         console.log(err);
    //         setErrorMessage("Invalid UserName or password. Please try again.");
    //         setTimeout(() => {
    //             setErrorMessage("");
    //         }, 5000);
    //     });
    // }

    // const handleSubmit1 = async (e) => {
    //     e.preventDefault();

    //     try {
    //         // const csrfResponse = await axios.get("http://172.16.119.156:8081/api/csrf", {
    //         const csrfResponse = await axios.get(LoginCSRF, {

    //             withCredentials: true
    //         });

    //         console.log("response", csrfResponse);

    //         const csrfToken = csrfResponse.headers["X-Csrf-Token"];
    //         console.log("CSRF Token:", csrfToken);

    //         const loginResponse = await
    //             // axios.post("http://172.16.119.156:8081/api/session/login",
    //             axios.post(LoginApi,
    //                 {
    //                     userId: values.email,
    //                     password: values.password
    //                 },
    //                 {
    //                     headers: {
    //                         "X-CSRF-TOKEN": csrfToken
    //                     },
    //                     withCredentials: true
    //                 }
    //             );

    //         console.log("Login Success:", loginResponse.data);
    //     } catch (err) {
    //         console.error("Login Error:", err);
    //     }
    // };

    useEffect(() => {
        if (!lockoutEndTime) return;

        const interval = setInterval(() => {
            const remaining = Math.max(0, Math.floor((lockoutEndTime - Date.now()) / 1000));
            setTimeLeft(remaining);

            if (remaining <= 0) {
                clearInterval(interval);
                setIsLoginDisabled(false);
                setFailCount(0);
                setLockoutEndTime(null);
                localStorage.removeItem("lockoutEndTime"); // ✅ clear storage
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [lockoutEndTime]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (powerUser) {
            await loginAsPowerUser();  // call only when checked
            return;
        }

        try {
            // Step 1: Call CSRF API — this sets JSESSIONID in browser automatically
            // const csrfResponse = await axios.get("http://172.16.119.156:8081/api/csrf", {
            const csrfResponse = await axios.get(LoginCSRF, {
                withCredentials: true
            });

            const csrfToken = csrfResponse.headers["x-csrf-token"];
            sessionStorage.setItem("tokenizedSession", csrfToken);

            // Step 2: Call login API — browser sends JSESSIONID only
            const res = await
                // axios.post(
                //     "http://172.16.119.156:8081/api/session/login",
                axios.post(LoginApi,
                    {
                        userId: values.email,
                        password: values.password
                    },
                    {
                        headers: {
                            "X-CSRF-TOKEN": csrfToken
                        },
                        withCredentials: true
                    }
                );

            console.log("Login Success:", res.data);

            if (res.data.status === "error") {
                if (res.data.message === "User account password expired." && res.data.first_login_flag === "Y") {
                    localStorage.setItem("userid", values.email);
                    localStorage.setItem("status", res.data.first_login_flag);
                    navigate("/ResetPassword");
                    return;
                } else {
                    setErrorMessage(res.data.message || "An error occurred. Please try again.");
                    return;
                }
            }

            if (!res.data.userAuth?.userId) {
                setErrorMessage("Invalid UserName or password. Please try again.");
                navigate("/");
                return;
            }

            if (res.data.userAuth.first_login_flag === "Y") {
                localStorage.setItem("userid", res.data.userAuth.userId);
                localStorage.setItem("status", res.data.userAuth.first_login_flag);
                navigate("/ResetPassword");
                return;
            }

            localStorage.setItem("username", res.data.userAuth.username);
            localStorage.setItem("userid", res.data.userAuth.userId);
            localStorage.setItem("lastLogin", res.data.userAuth.lastLogin);
            localStorage.setItem("originalUserRole", res.data.userAuth.userRole);
            localStorage.setItem("sessionId", res.data.sessionId);

            let role = res.data.userAuth.userRole;
            if (role === "Superuser") role = "Admin";
            localStorage.setItem("userRole", role);

            localStorage.setItem("Email_Id", res.data.userAuth.Email_Id);
            const dept = res.data.userAuth.Orghie;
            localStorage.setItem("dept", dept);
            sessionStorage.setItem("dept", dept);
            console.log("dept", dept);
            localStorage.setItem("uploaded_template_count", res.data.UserActivity.uploaded_template_count);
            localStorage.setItem("modified_template_count", res.data.UserActivity.modified_template_count);
            localStorage.setItem("download_data_count", res.data.UserActivity.download_data_count);

            localStorage.setItem("num_logins", res.data.UserSummary.num_logins);
            localStorage.setItem("last_activity", res.data.UserSummary.last_activity);
            localStorage.setItem("frequent_activity", res.data.UserSummary.frequent_activity);

            //organization hierarchy
            localStorage.setItem("Mapped_Name", res.data.UserOrganizationHierarchy.Mapped_Name);
            localStorage.setItem("Mapped_Role", res.data.UserOrganizationHierarchy.Mapped_Role);
            localStorage.setItem("Mapped_Email", res.data.UserOrganizationHierarchy.Mapped_Email);


            const activities = res.data.UserCompletedActivitiesCount || {};
            Object.keys(activities).forEach(activity => {
                const { tablenames, count } = activities[activity];
                localStorage.setItem(activity, JSON.stringify({ tablenames, count }));
            });

            if (activities.Data_Entry_Management_COM) {
                console.log("Data_Entry_Management_COM:", activities.Data_Entry_Management_COM);
                localStorage.setItem("Data_Entry_Management_COM", JSON.stringify(activities.Data_Entry_Management_COM));
            }

            const roleRouteMap = {
                Admin: "/gapsyAdashboard",
                Checker: "/gapsyCdashboard",
                Maker: "/gapsyMdashboard"
            };

            const targetRoute = roleRouteMap[role] || "/gapsyAdashboard";
            setIsLoggedIn(true);
            // navigate(targetRoute);
            navigate(targetRoute, { state: { showLoginSuccessModal: true } });


        } catch (err) {
            console.error("Error during login process:", err);

            if (err.response && err.response.data?.status === "success" && err.response.data?.failCount !== undefined) {
                const { failCount: count } = err.response.data;
                setFailCount(count);

                if (count > 5) {
                    const lockoutTime = Date.now() + 5 * 60 * 1000; // 5 minutes from now
                    setIsLoginDisabled(true);
                    setLockoutEndTime(lockoutTime);

                    // 🔽 Save lockout time to localStorage to persist across reloads
                    localStorage.setItem("lockoutEndTime", lockoutTime);

                    setErrorMessage("Account locked due to multiple failed attempts. Try again in 5 minutes.");
                } else {
                    setErrorMessage(`Invalid username or password. Attempt ${count}/5`);
                }
            } else {
                setErrorMessage("Invalid username or password. Please try again.");
            }

            setTimeout(() => {
                setErrorMessage("");
            }, 5000);
        }
    };

    const handleLogout = async () => {
        let csrfToken = sessionStorage.getItem("tokenizedSession");

        try {
            await axios.post(LogoutApi, {}, {
                headers: {
                    userId: values.email,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
            });
            localStorage.clear();
            sessionStorage.clear();
            navigate("/");
        } catch (error) {
            console.error(error);
        }
    };

    const loginAsPowerUser = async () => {
        
        try {
            // Step 1: Call CSRF API — this sets JSESSIONID in browser automatically
            // const csrfResponse = await axios.get("http://172.16.119.156:8081/api/csrf", {
            const csrfResponse = await axios.get(LoginCSRF, {
                withCredentials: true
            });

            const csrfToken = csrfResponse.headers["x-csrf-token"];
            sessionStorage.setItem("tokenizedSession", csrfToken);

            // Step 2: Call login API — browser sends JSESSIONID only
            const res = await axios.post(
                LoginApi,
                {
                    userId: values.email,
                    password: values.password
                },
                {
                    params: {
                        PowerUserLogin: "Y"   // correct way
                    },
                    headers: {
                        "X-CSRF-TOKEN": csrfToken
                    },
                    withCredentials: true
                }
            );
            console.log("Login Success:", res.data);

            const powerUserFlag = res.data.userAuth?.power_user_login;

            if (powerUserFlag === "N") {
                setErrorMessage("User is not a Power User");

                // small delay so user can see message
                setTimeout(async () => {
                    await handleLogout(csrfToken);
                }, 1500);

                return;
            }
            if (res.data.status === "error") {
                if (res.data.message === "User account password expired." && res.data.first_login_flag === "Y") {
                    localStorage.setItem("userid", values.email);
                    localStorage.setItem("status", res.data.first_login_flag);
                    navigate("/ResetPassword");
                    return;
                } else {
                    setErrorMessage(res.data.message || "An error occurred. Please try again.");
                    return;
                }
            }

            // const sessionId = res.data.sessionId;
            // setSessionId(sessionId);
            // if (!sessionId) {
            //     setErrorMessage("Session ID missing in response. Please try again.");
            //     return;
            // }

            if (!res.data.userAuth?.userId) {
                setErrorMessage("Invalid UserName or password. Please try again.");
                navigate("/");
                return;
            }

            if (res.data.userAuth.first_login_flag === "Y") {
                localStorage.setItem("userid", res.data.userAuth.userId);
                localStorage.setItem("status", res.data.userAuth.first_login_flag);
                navigate("/ResetPassword");
                return;
            }

            localStorage.setItem("username", res.data.userAuth.username);
            localStorage.setItem("userid", res.data.userAuth.userId);
            localStorage.setItem("lastLogin", res.data.userAuth.lastLogin);
            localStorage.setItem("originalUserRole", res.data.userAuth.userRole);
            localStorage.setItem("sessionId", res.data.sessionId);

            let role = res.data.userAuth.userRole;
            if (role === "Superuser") role = "Admin";
            localStorage.setItem("userRole", role);

            localStorage.setItem("Email_Id", res.data.userAuth.Email_Id);
            const dept = res.data.userAuth.Orghie;
            localStorage.setItem("dept", dept);
            sessionStorage.setItem("dept", dept);
            console.log("dept", dept);
            localStorage.setItem("uploaded_template_count", res.data.UserActivity.uploaded_template_count);
            localStorage.setItem("modified_template_count", res.data.UserActivity.modified_template_count);
            localStorage.setItem("download_data_count", res.data.UserActivity.download_data_count);

            localStorage.setItem("num_logins", res.data.UserSummary.num_logins);
            localStorage.setItem("last_activity", res.data.UserSummary.last_activity);
            localStorage.setItem("frequent_activity", res.data.UserSummary.frequent_activity);

            //organization hierarchy
            localStorage.setItem("Mapped_Name", res.data.UserOrganizationHierarchy.Mapped_Name);
            localStorage.setItem("Mapped_Role", res.data.UserOrganizationHierarchy.Mapped_Role);
            localStorage.setItem("Mapped_Email", res.data.UserOrganizationHierarchy.Mapped_Email);


            const activities = res.data.UserCompletedActivitiesCount || {};
            Object.keys(activities).forEach(activity => {
                const { tablenames, count } = activities[activity];
                localStorage.setItem(activity, JSON.stringify({ tablenames, count }));
            });

            if (activities.Data_Entry_Management_COM) {
                console.log("Data_Entry_Management_COM:", activities.Data_Entry_Management_COM);
                localStorage.setItem("Data_Entry_Management_COM", JSON.stringify(activities.Data_Entry_Management_COM));
            }

            const roleRouteMap = {
                Admin: "/GapsyCRODashboard",
                Checker: "/GapsyCRODashboard",
                Maker: "/GapsyCRODashboard"
            };

            const targetRoute = roleRouteMap[role] || "/GapsyCRODashboard";
            setIsLoggedIn(true);
            // navigate(targetRoute);
            navigate(targetRoute, { state: { showLoginSuccessModal: true } });


        } catch (err) {
            console.error("Error during login process:", err);

            if (err.response && err.response.data?.status === "success" && err.response.data?.failCount !== undefined) {
                const { failCount: count } = err.response.data;
                setFailCount(count);

                if (count > 5) {
                    const lockoutTime = Date.now() + 5 * 60 * 1000; // 5 minutes from now
                    setIsLoginDisabled(true);
                    setLockoutEndTime(lockoutTime);

                    // 🔽 Save lockout time to localStorage to persist across reloads
                    localStorage.setItem("lockoutEndTime", lockoutTime);

                    setErrorMessage("Account locked due to multiple failed attempts. Try again in 5 minutes.");
                } else {
                    setErrorMessage(`Invalid username or password. Attempt ${count}/5`);
                }
            } else {
                setErrorMessage("Invalid username or password. Please try again.");
            }

            setTimeout(() => {
                setErrorMessage("");
            }, 5000);
        }
    };

    // const handlePowerUser = async (e) => {
    //     e.preventDefault();

    //     const csrfResponse = await axios.get(LoginCSRF, {
    //         withCredentials: true
    //     });

    //     const csrfToken = csrfResponse.headers["x-csrf-token"];

    //     try {
    //         const rafRes = await axios.post(
    //             LoginRaf,
    //             {}, // empty body
    //             {
    //                 params: {
    //                     userId: values.email   // ✅ query param
    //                 },
    //                 headers: {
    //                     "X-CSRF-TOKEN": csrfToken
    //                 },
    //                 withCredentials: true
    //             }
    //         );

    //         console.log("RAF Response:", rafRes.data);

    //         const rafData =
    //             rafRes.data?.CONFIG_RAF_USERROLE_MAPPING?.data?.[0];

    //         const isActive = rafData?.ACTIVE_YN;

    //         if (isActive === "Y") {
    //             handleSubmit({ preventDefault: () => { } });
    //         } else {
    //             setErrorMessage("User is not Poweruser");
    //         }

    //     } catch (err) {
    //         console.error("RAF API Error:", err);
    //         setErrorMessage("Error validating Poweruser");
    //     }
    // };

    if (isLoggedIn) {
        return <Navigate to="/Dashboard" />;
    }

    const handleLogin = (e) => {
        e.preventDefault();
        // Add login logic here
        console.log('Logging in...');
    };

    return (
        <div className="container-fluid h-100">
            <div className="row h-100 flex-column flex-md-row">

                {/* Left Section */}
                <div className={`col-md-6 ${styles.leftSection}`}>
                    <div>
                        <h2 className={`mb-0 ${styles.h2LogoFont}`}>
                            <img
                                src={require('../assets/images/gapsphere.ai.png')}
                                alt="Gapsphere.AI"
                                // src={require('../assets/images/anb-logo.png')}
                                // alt="ANB.AI"
                                className="img-fluid"
                                style={{
                                    maxHeight: '150px', filter: `
                                    drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2))
                                    drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.3))
                                    drop-shadow(4px 6px 6px rgba(0, 0, 0, 0.15))
                                `
                                }} // adjust height as needed
                            />
                        </h2>
                        <h3 className={`fw-bold ${styles.fadeIn}`}>
                            {dynamicSlides[slideIndex].title}
                        </h3>
                        <p className={`${styles.lead} ${styles.fadeIn}`} style={{ minHeight: "2.5rem" }}>
                            {dynamicSlides[slideIndex].lead || " "}
                        </p>
                    </div>
                </div>

                {/* Right Section */}
                {/* // src={require('../assets/images/anb-logo.png')}
                                // alt="ANB.AI" */}

                <div className={`col-md-6 ${styles.rightSection}`}>

                    <form className={styles.loginForm} onSubmit={handleSubmit}>

                        {/* <div className="text-center mb-4">
                            <img
                                src={require('../assets/images/anb-logo.png')}
                                alt="ANB"
                                className="img-fluid"
                                style={{
                                    maxHeight: '100px',
                                    filter: `
                    drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2))
                    drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.3))
                    drop-shadow(4px 6px 6px rgba(0, 0, 0, 0.15))
                `
                                }}
                            />
                        </div> */}

                        <h3 className="mb-3 text-center">Sign In</h3>
                        <p className="text-muted text-center mb-4">
                            Use your credentials to continue
                        </p>
                        {/* Username */}
                        <div className="input-group mb-3">
                            <span className={`input-group-text ${styles.inputGroupText}`}>
                                <i className="bi bi-person"></i>
                            </span>
                            <input type="text" className="form-control" placeholder="Username" required onChange={(e) => setValues({ ...values, email: e.target.value })} />
                        </div>

                        {/* Password */}
                        <div className="input-group mb-3">
                            <span className={`input-group-text ${styles.inputGroupText}`}>
                                <i className="bi bi-lock"></i>
                            </span>
                            <input
                                type={passwordVisible ? 'text' : 'password'}
                                className="form-control"
                                placeholder="Password"
                                required
                                onChange={(e) => setValues({ ...values, password: e.target.value })}
                            />
                            <span
                                className={`input-group-text ${styles.inputGroupText}`}
                                onClick={togglePassword}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className={`bi ${passwordVisible ? 'bi-eye-slash' : 'bi-eye'}`} />
                            </span>
                        </div>

                        {/* Remember Me */}
                        {/* <div className="form-check mb-3">
                            <input className="form-check-input" type="checkbox" id="rememberMe" />
                            <label className="form-check-label" htmlFor="rememberMe">
                                Remember Me
                            </label>
                        </div> */}

                        <div className="d-flex justify-content-between mb-3">

                            {/* Left side */}
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="rememberMe"
                                />
                                <label className="form-check-label" htmlFor="rememberMe">
                                    Remember Me
                                </label>
                            </div>

                            {/* Right side */}
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="powerUser"
                                    checked={powerUser}
                                    onChange={(e) => setPowerUser(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="powerUser">
                                    Power BI User
                                </label>
                            </div>
                        </div>

                        {/* Login Button */}
                        <div className="d-grid mb-3">
                            {/* <button type="submit" className={`btn ${styles.btnGradient}`}>Login</button> */}
                            <button
                                type="submit"
                                className={`btn ${styles.btnGradient}`}
                                disabled={isLoginDisabled}
                            >
                                {isLoginDisabled
                                    ? `Login Disabled (${Math.floor(timeLeft / 60)}:${(timeLeft % 60).toString().padStart(2, "0")})`
                                    : "Login"}
                            </button>

                        </div>
                        {errorMessage &&
                            <div
                                className="alert alert-dismissible fade show"
                                role="alert"
                                style={{
                                    color: " #1976d2",
                                    padding: "1px",  // Adjust padding as needed
                                    margin: "1px 0",  // Adjust margin as needed
                                    position: "relative",  // Adjust position if needed
                                    fontSize: '15px'
                                }}
                            >
                                {errorMessage}
                            </div>
                        }
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
